export default __webpack_public_path__ + "static/media/rank-2.d604ce11.webp";